import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-fir-dividends-payment',
    templateUrl: './fir-dividends-payment.component.html',
    styleUrls: ['./fir-dividends-payment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FirDividendsPaymentComponent implements OnInit, OnDestroy {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly contextSubs = new Subscription();
  private isInitialized = false;

  baseURLs: GtwElementsBaseUrlsModel = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  modalTitle = 'Dividends Payment';
  dividends_data: any[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryInit();
    this.contextSubs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.isInitialized = false;
        this.applyWorkspaceContext();
        this.tryInit();
      })
    );
    this.contextSubs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.isInitialized = false;
        this.applyWorkspaceContext();
        this.tryInit();
      })
    );
  }

  ngOnDestroy(): void {
    this.contextSubs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const shell = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    const hydrated = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    let fp = normalizeFilterParams(activeScreen);
    if (!Object.keys(fp).length) {
      fp = extractObject(hydrated);
    }
    this.filterParams = fp;
    const mergedGp = { ...extractObject(shell.globalParams), ...extractObject(hydrated) };
    this.globalService = {
      ...shell,
      globalParams: mergedGp,
      filterParams: fp,
      workspaceFactory: this.gtwWorkspace.workspaceFactory,
      inputs: this.gtwGlobal.inputs,
      sso_id: this.gtwApp?.USER_SETTINGS?.user?.sso_id ?? ''
    };
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = { ...gc, base_url: gc.base_url || gc.api || '' };
    this.baseURLs = gc;
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);
  }

  private tryInit() {
    if (this.isInitialized) {
      return;
    }
    // `globalService` defaults to `{}` (truthy); require real header payload before one-shot init.
    const rowReady =
      this.rowData != null &&
      typeof this.rowData === 'object' &&
      Object.keys(this.rowData).length > 0;
    const headerReady = this.globalService != null && Object.keys(this.globalService).length > 0;
    if (!headerReady || !rowReady) {
      return;
    }
    this.isInitialized = true;
    this.init();
  }

  private init() {
    try {
      this.dividends_data = this.rowData?.dividends_data || [];
      this.cdr.detectChanges();
    } catch (e) {
      console.error('Error in init:', e);
    }
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
